type RequestOption = {
  url: `/${string}` | string
  method?: 'POST' | 'GET' | 'PUT' | 'DELETE' | 'PATCH'
  contentType?: 'application/json' | 'multipart/form-data' | 'image/jpeg'
  data?: unknown
  params?: unknown
  signal?: AbortController['signal']
}

/**
 * Выполняет запрос по-указанному URL-адресу, используя предоставленные параметры.
 * @param {RequestOption} options - Данные для запроса
 * @param {string} options.url - URL-адрес, на который следует сделать запрос.
 * @param {string} [options.method] - Метод HTTP, используемый для запроса.
 * @param {string} [options.contentType] -Тип для content type запроса.
 * @param {any} options.data - Данные для отправки в теле запроса.
 * @param {any} options.params - Данные для query-параметров.
 * @param {AbortController['signal']} options.signal - Нужна ли капча в запросе.
 * @return {Promise<T>} Возвращаемое значение запроса.
 */
export async function sendRequest<T>({
  url,
  method = 'POST',
  contentType = 'application/json',
  data,
  params,
  signal,
}: RequestOption): Promise<T> {
  let body: unknown

  if (contentType === 'application/json') {
    body = JSON.stringify(data)
  } else {
    body = data
  }

  const headers = {
    'Content-Type': contentType,
  }
  const response = await window.axios(url, {
    method,
    headers,
    data: body,
    params,
    signal,
  })

  return await response.data
}

export * from './types'
